// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___ih9zW","root__wrapper":"style-module__root__wrapper___enjh1","container":"style-module__container___v9ahO","text":"style-module__text___SGFNl","img1":"style-module__img1___0VfqJ","img2":"style-module__img2___uTJjF"};
    if(module.hot) {
      // 1729151121739
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  